/* eslint-disable react/jsx-key */
import React from 'react';
import classNames from 'classnames';
import { useTheme } from 'next-themes';

import { ETheme } from '@/enums/theme';
import { Moon, Sun } from '@/icons/index';

import styles from './styles.module.scss';

const DayNightSwitch = () => {
  const themeIcons = [<Sun />, <Moon />];
  const { theme, setTheme } = useTheme();
  const isLightMode = theme === ETheme.LIGHT_MODE;
  if (typeof window === 'undefined') {
    return null;
  }
  return (
    <div
      className={styles.container}
      itemScope
      itemType='http://schema.org/Thing'
    >
      <div className={classNames(styles.indicator)} />
      {themeIcons.map((item, index) => {
        return (
          <button
            key={index}
            className={classNames([styles.button], {
              [styles.active]:
                (index === 0 && isLightMode) || (index === 1 && !isLightMode),
            })}
            onClick={() => {
              setTheme(
                theme === ETheme.LIGHT_MODE
                  ? ETheme.DARK_MODE
                  : ETheme.LIGHT_MODE,
              );
            }}
            data-testid={`switch-${index === 0 ? 'light' : 'dark'}`}
            aria-label={item}
          >
            {item}
          </button>
        );
      })}
    </div>
  );
};

export default DayNightSwitch;
